import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {FieldDefinition} from "@shared/models/field-definition";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {Router} from "@angular/router";

@Component({
    standalone: false,
    selector: 'particle-participants-entity-count-cell-viewer',
  templateUrl: './participants-entity-count-cell-viewer.component.html',
  styleUrls: ['./participants-entity-count-cell-viewer.component.scss']
})
export class ParticipantsEntityCountCellViewerComponent implements OnInit, CellComponent {
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  icon: string;
  disabled: boolean;
  constructor(private router: Router) { }

  ngOnInit() {
  }
  onClicked(action: string) {
    if ((this.item && !this.item.isReadOnly) || (this.fieldDefinition && this.fieldDefinition.metaData && this.fieldDefinition.metaData.CanCellUnlock === 'true')) {
      this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: action}});
    }
  }
}
